import React from "react";

const FirestoreListener = () => null;

export default FirestoreListener;
